/* eslint-disable sonarjs/cognitive-complexity */
import type { CosmicHeaderSection } from '@/lib/cms/cosmic/types/CosmicHeaderType'
import DesktopMenuColumns from '../DesktopHeader/DesktopMenuColumns'
import DesktopMenuPromotion from '../DesktopHeader/DesktopMenuPromotion'
import { MobileMenuColumns } from '../MobileHeader/MobileDrawer/MobileMenuColumns'

type Props = {
  section: CosmicHeaderSection
  isMobile?: boolean
}

export const renderSection = ({ section, isMobile = false }: Props) => {
  if (!isMobile) {
    if (section.columns.columns && section.promotion) {
      return <DesktopMenuColumns columns={section.columns.columns} />
    }

    if (section.columns.columns) {
      return <DesktopMenuColumns columns={section.columns.columns} />
    }

    if (section.promotion) {
      return <DesktopMenuPromotion promotion={section.promotion} />
    }
  } else {
    if (section.columns.columns && section.promotion) {
      return <MobileMenuColumns columns={section.columns.columns} />
    }

    if (section.columns.columns) {
      return <MobileMenuColumns columns={section.columns.columns} />
    }

    if (section.promotion) {
      return null // Promotions are rendered differently on mobile
    }
  }

  return null
}
